const getters = {
  token: state => state.user.token,
  userId: state => state.user.userId,
  userName: state => state.user.userName,
  userMobile: state => state.user.userMobile,
  createPermission: state => state.user.createPermission,
  exportPermission: state => state.user.exportPermission,
  customerManagePermission: state => state.user.customerManagePermission,
  customerAuditPermission: state => state.user.customerAuditPermission,
  superUser: state => state.user.superUser,
  superQueryUser: state => state.user.superQueryUser,
  userFactory: state => state.user.userFactory,
  getShowTabbar: state => state.user.showTabbar,
  name: state => state.user.name,
  phone: state => state.user.phone,
  idCard: state => state.user.idCard,
  userType: state => state.user.userType,
  viewPermission: state => state.user.viewPermission,
  auditPermission: state => state.user.auditPermission,
}
export default getters
